import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Deal_1 from '../../../assets/images/home_page_5/deals/01.png'
import Deal_2 from '../../../assets/images/home_page_5/deals/02.png'
import Deal_3 from '../../../assets/images/home_page_5/deals/03.png'
import Deal_4 from '../../../assets/images/home_page_5/deals/04.png'
import Deal_5 from '../../../assets/images/home_page_5/deals/05.png'
import Deal_6 from '../../../assets/images/home_page_5/deals/06.png'
import Deal_7 from '../../../assets/images/home_page_5/deals/07.png'
import Deal_8 from '../../../assets/images/home_page_5/deals/08.png'
import Deal_9 from '../../../assets/images/home_page_5/deals/09.png'
import Deal_10 from '../../../assets/images/home_page_5/deals/10.png'

const Deals = () => {
    const [Catageory, setCategory] = useState(" Latest Products")
    const handleTabchange = (tab) => {
        setCategory(tab)
    }
    return (
        <>
            <section id="deals-product-five" className="deals-product-five-main-block">
                <div className="container-fluid">
                    <div className="deals-product-five-border">
                        <div className="row">
                            <div className="col-lg-4 col-md-5">
                                <div className="section">
                                    <h6 className="section-heading-five">Deals Of The Day</h6>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-7">
                                <ul
                                    className="nav nav-pills float-lg-end float-start"
                                    id="pills-tab"
                                    role="tablist"
                                >
                                    <li className="nav-item" role="presentation">
                                        <Link
                                            className={`nav-link ${Catageory === " Latest Products" ? "active" : "Show"}`}
                                            onClick={() => handleTabchange(" Latest Products")}
                                            id="pills-tab1-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-tab1"
                                            role="tab"
                                            aria-controls="pills-tab1"
                                            aria-selected="true"
                                        >
                                            Latest Products
                                        </Link>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <Link
                                            className={`nav-link ${Catageory === " Top Rating" ? "active" : ""}`}
                                            onClick={() => handleTabchange(" Top Rating")}
                                            id="pills-tab2-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-tab2"
                                            role="tab"
                                            aria-controls="pills-tab2"
                                            aria-selected="false"
                                        >
                                            Top Rating
                                        </Link>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <Link
                                            className={`nav-link ${Catageory === "Best Selling" ? "active" : ""}`}
                                            onClick={() => handleTabchange(" Best Selling")}
                                            id="pills-tab3-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-tab3"
                                            role="tab"
                                            aria-controls="pills-tab3"
                                            aria-selected="false"
                                        >
                                            Best Selling
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="tab-content" id="pills-tabContent">
                        <div
                            className={`tab-pane fade ${Catageory === ' Latest Products' ? 'show active' : ''}`}
                            id="pills-tab1"
                            role="tabpanel"
                            aria-labelledby="pills-tab1-tab"

                        >
                            <div className="row">
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_1}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_5}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_6}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_7}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_8}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_9}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_10}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`tab-pane fade ${Catageory === ' Top Rating' ? 'show active' : ''}`}
                            id="pills-tab2"
                            role="tabpanel"
                            aria-labelledby="pills-tab2-tab"
                        >
                            <div className="row">
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_1}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_5}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`tab-pane fade ${Catageory === ' Best Selling' ? 'show active' : ''}`}
                            id="pills-tab3"
                            role="tabpanel"
                            aria-labelledby="pills-tab3-tab"
                        >
                            <div className="row">
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_6}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_7}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_8}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_9}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-five">
                                    <div className="deals-product-five-block">
                                        <div className="deals-product-five-img text-center">
                                            <Link to="/Shopdetails" title="">
                                                <img
                                                    src={Deal_10}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-five-dtls">
                                            <h6 className="deals-product-five-name">
                                                <Link to="/Shopdetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <ul className="deals-product-five-price">
                                                <li className="price">$159.77</li>
                                                <li className="discount-price">
                                                    <s>$159.77</s>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Deals
